export const tabs = [
  {
    id: 0,
    name: 'chat',
    label: 'conversation.tabs.askAnything',
    icon: 'magic',
  },
  {
    id: 1,
    name: 'prompts',
    label: 'conversation.tabs.promptCards',
    icon: 'prompt-cards',
  },
  {
    id: 2,
    name: 'filters,',
    label: 'conversation.tabs.setFilters',
    icon: 'filters',
  },
];
